/* Otokasım Theme — global.js */
(function () {
  'use strict';

  /* ---------- Toast ---------- */
  let toastTimer;
  window.okToast = function (message) {
    const toast = document.getElementById('ok-toast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2600);
  };

  /* ---------- Mobil menü ---------- */
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-drawer-toggle]');
    if (toggle) {
      const drawer = document.getElementById('MobileDrawer');
      const overlay = document.getElementById('DrawerOverlay');
      const open = !drawer.classList.contains('is-open');
      drawer.classList.toggle('is-open', open);
      overlay.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    }
    if (e.target.closest('#DrawerOverlay')) {
      document.getElementById('MobileDrawer').classList.remove('is-open');
      document.getElementById('DrawerOverlay').classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  /* ---------- Hero slider ---------- */
  document.querySelectorAll('[data-hero-slider]').forEach((slider) => {
    const track = slider.querySelector('.hero-slider__track');
    const slides = slider.querySelectorAll('.hero-slide');
    const dots = slider.querySelectorAll('.hero-slider__dot');
    const autoplay = slider.dataset.autoplay === 'true';
    const speed = parseInt(slider.dataset.speed || '5', 10) * 1000;
    let index = 0;
    let timer;

    if (slides.length < 2) return;

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach((d, di) => d.classList.toggle('is-active', di === index));
    }
    function restart() {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(() => goTo(index + 1), speed);
    }
    slider.querySelector('[data-slide-prev]')?.addEventListener('click', () => { goTo(index - 1); restart(); });
    slider.querySelector('[data-slide-next]')?.addEventListener('click', () => { goTo(index + 1); restart(); });
    dots.forEach((d, di) => d.addEventListener('click', () => { goTo(di); restart(); }));

    let startX = 0;
    track.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { goTo(index + (dx < 0 ? 1 : -1)); restart(); }
    }, { passive: true });

    restart();
  });

  /* ---------- Adet seçici ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    const input = btn.closest('.quantity-selector').querySelector('input');
    const delta = parseInt(btn.dataset.qtyChange, 10);
    const next = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Sepete ekle (AJAX) ---------- */
  async function addToCart(variantId, quantity) {
    const res = await fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'Sepete eklenemedi');
    }
    return res.json();
  }

  async function refreshCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    } catch (e) { /* yut */ }
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    try {
      await addToCart(btn.dataset.quickAdd, 1);
      await refreshCartCount();
      window.okToast('Ürün sepete eklendi ✓');
    } catch (err) {
      window.okToast(err.message);
    } finally {
      btn.disabled = false;
    }
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const variantId = form.querySelector('[name="id"]').value;
    const qty = parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10);
    btn.disabled = true;
    try {
      await addToCart(variantId, qty);
      await refreshCartCount();
      window.okToast('Ürün sepete eklendi ✓');
    } catch (err) {
      window.okToast(err.message);
    } finally {
      btn.disabled = false;
    }
  });

  /* ---------- Favoriler & Karşılaştırma (localStorage) ---------- */
  const store = {
    get(key) {
      try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; }
    },
    set(key, list) { localStorage.setItem(key, JSON.stringify(list)); }
  };

  const WISHLIST_KEY = 'otokasim:wishlist';
  const COMPARE_KEY = 'otokasim:compare';

  function syncButtons() {
    const wishlist = store.get(WISHLIST_KEY).map((p) => p.handle);
    const compare = store.get(COMPARE_KEY).map((p) => p.handle);
    document.querySelectorAll('[data-wishlist-toggle]').forEach((b) => {
      b.classList.toggle('is-active', wishlist.includes(b.dataset.handle));
    });
    document.querySelectorAll('[data-compare-toggle]').forEach((b) => {
      b.classList.toggle('is-active', compare.includes(b.dataset.handle));
    });
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      const n = wishlist.length;
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function toggleItem(key, btn, addedMsg, removedMsg, limit) {
    const list = store.get(key);
    const handle = btn.dataset.handle;
    const idx = list.findIndex((p) => p.handle === handle);
    if (idx >= 0) {
      list.splice(idx, 1);
      window.okToast(removedMsg);
    } else {
      if (limit && list.length >= limit) {
        window.okToast(window.themeStrings.compareLimit);
        return;
      }
      list.push({
        handle: handle,
        title: btn.dataset.title,
        url: btn.dataset.url,
        image: btn.dataset.image,
        price: btn.dataset.price,
        sku: btn.dataset.sku || '',
        vendor: btn.dataset.vendor || '',
        available: btn.dataset.available === 'true'
      });
      window.okToast(addedMsg);
    }
    store.set(key, list);
    syncButtons();
  }

  document.addEventListener('click', (e) => {
    const wBtn = e.target.closest('[data-wishlist-toggle]');
    if (wBtn) {
      e.preventDefault();
      toggleItem(WISHLIST_KEY, wBtn, window.themeStrings.addedToWishlist, window.themeStrings.removedFromWishlist);
      renderWishlistPage();
    }
    const cBtn = e.target.closest('[data-compare-toggle]');
    if (cBtn) {
      e.preventDefault();
      toggleItem(COMPARE_KEY, cBtn, window.themeStrings.addedToCompare, window.themeStrings.removedFromCompare, 4);
      renderComparePage();
    }
    if (e.target.closest('[data-compare-clear]')) {
      store.set(COMPARE_KEY, []);
      syncButtons();
      renderComparePage();
    }
  });

  /* Favoriler sayfası render */
  function renderWishlistPage() {
    const grid = document.getElementById('WishlistGrid');
    if (!grid) return;
    const list = store.get(WISHLIST_KEY);
    const empty = document.getElementById('WishlistEmpty');
    if (empty) empty.hidden = list.length > 0;
    grid.hidden = list.length === 0;
    grid.innerHTML = list.map((p) => `
      <li class="product-card">
        <div class="product-card__actions">
          <button class="card-action-btn is-active" data-wishlist-toggle data-handle="${p.handle}" aria-label="Favorilerden çıkar">
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 21s-7.5-4.9-10-9.3C.4 8.6 2.2 5 5.7 5c2 0 3.4 1.1 4.3 2.6C10.9 6.1 12.3 5 14.3 5c3.5 0 5.3 3.6 3.7 6.7C19.5 16.1 12 21 12 21z"/></svg>
          </button>
        </div>
        <a class="product-card__media" href="${p.url}">
          ${p.image ? `<img src="${p.image}" alt="${p.title}" loading="lazy">` : ''}
        </a>
        <div class="product-card__info">
          ${p.vendor ? `<span class="product-card__vendor">${p.vendor}</span>` : ''}
          <h3 class="product-card__title"><a href="${p.url}">${p.title}</a></h3>
          ${p.sku ? `<span class="product-card__sku">Ürün Kodu: ${p.sku}</span>` : ''}
          <div class="product-card__bottom">
            <div class="price"><span class="price__current">${p.price}</span></div>
          </div>
        </div>
      </li>`).join('');
  }

  /* Karşılaştırma sayfası render */
  function renderComparePage() {
    const wrap = document.getElementById('CompareTable');
    if (!wrap) return;
    const list = store.get(COMPARE_KEY);
    const empty = document.getElementById('CompareEmpty');
    if (empty) empty.hidden = list.length > 0;
    const actions = document.getElementById('CompareActions');
    if (actions) actions.hidden = list.length === 0;
    wrap.hidden = list.length === 0;
    if (!list.length) { wrap.innerHTML = ''; return; }
    const s = window.compareStrings || {};
    wrap.innerHTML = `
      <div class="compare-table-wrapper"><table class="compare-table">
        <tr><th></th>${list.map((p) => `<td>
          ${p.image ? `<img src="${p.image}" alt="${p.title}">` : ''}
          <p style="margin-top:.8rem"><a href="${p.url}"><strong>${p.title}</strong></a></p>
          <button class="cart-item__remove" data-compare-toggle data-handle="${p.handle}">${s.remove || 'Kaldır'}</button>
        </td>`).join('')}</tr>
        <tr><th>${s.price || 'Fiyat'}</th>${list.map((p) => `<td>${p.price}</td>`).join('')}</tr>
        <tr><th>${s.sku || 'Ürün Kodu'}</th>${list.map((p) => `<td>${p.sku || '—'}</td>`).join('')}</tr>
        <tr><th>${s.vendor || 'Marka'}</th>${list.map((p) => `<td>${p.vendor || '—'}</td>`).join('')}</tr>
        <tr><th>${s.availability || 'Stok'}</th>${list.map((p) => `<td>${p.available ? '<span class="badge badge--stock">Stokta</span>' : '<span class="badge badge--soldout">Tükendi</span>'}</td>`).join('')}</tr>
      </table></div>`;
  }

  /* ---------- Ürün galerisi ---------- */
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-product-gallery]');
    const main = gallery.querySelector('[data-gallery-main] img');
    main.src = thumb.dataset.fullSrc;
    main.srcset = '';
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((t) => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
  });

  /* ---------- Varyant seçimi ---------- */
  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const form = select.closest('form[data-product-form]');
      const option = select.options[select.selectedIndex];
      form.querySelector('[name="id"]').value = option.value;
      const priceEl = document.querySelector('[data-product-price]');
      if (priceEl && option.dataset.price) priceEl.textContent = option.dataset.price;
      const btn = form.querySelector('[type="submit"]');
      const available = option.dataset.available === 'true';
      btn.disabled = !available;
      btn.textContent = available ? btn.dataset.addLabel : btn.dataset.soldoutLabel;
    });
  });

  /* ---------- Şasi (VIN) formu ---------- */
  document.querySelectorAll('form[data-vin-form]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      const vinInput = form.querySelector('[data-vin-input]');
      if (!vinInput) return;
      const vin = vinInput.value.replace(/\s/g, '').toUpperCase();
      vinInput.value = vin;
      if (vin.length !== 17) {
        e.preventDefault();
        window.okToast(window.themeStrings.invalidVin);
        vinInput.focus();
      }
    });
  });

  /* WhatsApp'tan VIN sorgusu */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-vin-whatsapp]');
    if (!btn) return;
    e.preventDefault();
    const form = btn.closest('form');
    const vin = (form.querySelector('[data-vin-input]')?.value || '').replace(/\s/g, '').toUpperCase();
    const part = form.querySelector('[name="contact[parca]"]')?.value || '';
    if (vin.length !== 17) {
      window.okToast(window.themeStrings.invalidVin);
      return;
    }
    const number = btn.dataset.number;
    const msg = encodeURIComponent('Merhaba, şasi numarası ile parça sorgulamak istiyorum.\nŞasi No: ' + vin + (part ? '\nAradığım parça: ' + part : ''));
    window.open('https://wa.me/' + number + '?text=' + msg, '_blank', 'noopener');
  });

  /* ---------- Yağ seçici ---------- */
  /* "2015-2020" aralığını veya "2015, 2017" listesini yıl dizisine çevirir */
  function expandYears(str) {
    const out = [];
    String(str || '').split(',').map((t) => t.trim()).filter(Boolean).forEach((t) => {
      const m = t.match(/^(\d{4})\s*-\s*(\d{4})$/);
      if (m) {
        for (let y = parseInt(m[1], 10); y <= parseInt(m[2], 10); y++) out.push(String(y));
      } else {
        out.push(t);
      }
    });
    return out;
  }

  document.querySelectorAll('[data-oil-selector]').forEach((widget) => {
    const brandSel = widget.querySelector('[data-oil-brand]');
    const modelSel = widget.querySelector('[data-oil-model]');
    const yearSel = widget.querySelector('[data-oil-year]');
    const submitBtn = widget.querySelector('[data-oil-submit]');
    const data = {};
    try {
      const rows = JSON.parse(widget.querySelector('[data-oil-data]').textContent) || [];
      rows.forEach((r) => {
        if (!r || !r.brand || !r.model) return;
        data[r.brand] = data[r.brand] || {};
        data[r.brand][r.model] = expandYears(r.years);
      });
    } catch (e) { /* boş */ }

    function fillSelect(sel, values, placeholder) {
      sel.innerHTML = '<option value="">' + placeholder + '</option>' +
        values.map((v) => '<option value="' + v + '">' + v + '</option>').join('');
      sel.disabled = values.length === 0;
    }

    fillSelect(brandSel, Object.keys(data), brandSel.dataset.placeholder);
    fillSelect(modelSel, [], modelSel.dataset.placeholder);
    fillSelect(yearSel, [], yearSel.dataset.placeholder);

    brandSel.addEventListener('change', () => {
      const models = data[brandSel.value] ? Object.keys(data[brandSel.value]) : [];
      fillSelect(modelSel, models, modelSel.dataset.placeholder);
      fillSelect(yearSel, [], yearSel.dataset.placeholder);
    });
    modelSel.addEventListener('change', () => {
      const years = (data[brandSel.value] && data[brandSel.value][modelSel.value]) || [];
      fillSelect(yearSel, years, yearSel.dataset.placeholder);
    });
    submitBtn.addEventListener('click', () => {
      if (!brandSel.value || !modelSel.value || !yearSel.value) {
        window.okToast(widget.dataset.noSelectionMsg);
        return;
      }
      const base = widget.dataset.collectionUrl || '/collections/motor-yaglari';
      const tag = (brandSel.value + '-' + modelSel.value + '-' + yearSel.value)
        .toLocaleLowerCase('tr').replace(/\s+/g, '-')
        .replace(/ı/g, 'i').replace(/ğ/g, 'g').replace(/ü/g, 'u')
        .replace(/ş/g, 's').replace(/ö/g, 'o').replace(/ç/g, 'c');
      window.location.href = base + '/' + encodeURIComponent(tag);
    });
  });

  /* ---------- Koleksiyon: mobil filtre & sıralama ---------- */
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-facets-open]')) document.querySelector('.facets')?.classList.add('is-open');
    if (e.target.closest('[data-facets-close]')) document.querySelector('.facets')?.classList.remove('is-open');
  });
  document.querySelectorAll('[data-sort-select]').forEach((sel) => {
    sel.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location.href = url.toString();
    });
  });
  document.querySelectorAll('form[data-facets-form]').forEach((form) => {
    form.addEventListener('change', (e) => {
      if (e.target.matches('input[type="checkbox"]')) form.submit();
    });
  });

  /* ---------- Filtre: uzun listelerde ara ---------- */
  document.addEventListener('input', (e) => {
    if (!e.target.matches('[data-facet-search]')) return;
    const q = e.target.value.trim().toLocaleLowerCase('tr');
    e.target.nextElementSibling.querySelectorAll('[data-facet-value]').forEach((l) => {
      l.hidden = q !== '' && !l.dataset.facetValue.toLocaleLowerCase('tr').includes(q);
    });
  });

  /* ---------- Garajım: araç seçici ---------- */
  const GARAGE_KEY = 'otokasim:garaj';
  document.querySelectorAll('[data-garage]').forEach((g) => {
    let data;
    try { data = JSON.parse(g.querySelector('[data-garage-data]').textContent); } catch (e) { return; }
    const makeSel = g.querySelector('[data-garage-make]');
    const modelSel = g.querySelector('[data-garage-model]');
    const form = g.querySelector('.garage__form');
    const current = g.querySelector('[data-garage-current]');
    const applyLink = g.querySelector('[data-garage-apply]');
    // param: sayfada "Araç Modeli" filtresi varsa seçim bu sayfayı süzer, yoksa model sayfasına gidilir.
    const param = g.dataset.param;
    const active = (g.dataset.active || '').split('|').filter(Boolean);
    const filterUrl = (value) => {
      const url = new URL(window.location.href);
      url.searchParams.delete(param);
      url.searchParams.delete('page');
      url.searchParams.append(param, value);
      return url.toString();
    };
    const fillModels = (i) => {
      const models = i === '' ? [] : data[i].m;
      modelSel.length = 1;
      models.forEach((m, j) => modelSel.add(new Option(m.t, j)));
      modelSel.disabled = models.length === 0;
    };
    makeSel.addEventListener('change', () => fillModels(makeSel.value));

    g.querySelector('[data-garage-go]').addEventListener('click', () => {
      if (makeSel.value === '') { makeSel.focus(); return; }
      const make = data[makeSel.value];
      const model = modelSel.value === '' ? null : make.m[modelSel.value];
      const v = { name: model ? make.t + ' ' + model.t : make.t, value: model ? make.t + ' ' + model.t : '', url: model ? model.u : make.u };
      try { store.set(GARAGE_KEY, v); } catch (e) { /* gizli sekme: hatırlanmaz, yönlendirme yine çalışır */ }
      window.location.href = param && v.value ? filterUrl(v.value) : v.url;
    });

    g.querySelector('[data-garage-clear]').addEventListener('click', () => {
      try { localStorage.removeItem(GARAGE_KEY); } catch (e) { /* yok say */ }
      current.hidden = true;
      form.hidden = false;
    });

    const saved = store.get(GARAGE_KEY);
    if (saved && saved.name) {
      g.querySelector('[data-garage-name]').textContent = saved.name;
      current.hidden = false;
      form.hidden = true;
      const onOwnPage = saved.url && new URL(saved.url, window.location.origin).pathname === window.location.pathname;
      if (param && saved.value && !active.includes(saved.value) && !onOwnPage) {
        applyLink.href = filterUrl(saved.value);
        applyLink.hidden = false;
      } else if (!param && !onOwnPage) {
        applyLink.href = saved.url;
        applyLink.hidden = false;
      }
    }
  });

  /* ---------- init ---------- */
  document.addEventListener('DOMContentLoaded', () => {
    syncButtons();
    renderWishlistPage();
    renderComparePage();
    refreshCartCount();
  });
})();
